import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";
import { OverridableComponent } from "@mui/material/OverridableComponent";
import { SvgIconTypeMap } from "@mui/material";

const PolicyManagementIcon: OverridableComponent<
  SvgIconTypeMap<{}, "svg">
> & { muiName: string } = (props: SvgIconProps) => {
  const { width = 72, height = 72, color = "#9E233A", ...otherProps } = props;

  return (
    <SvgIcon
      {...otherProps}
      viewBox="0 0 72 72"
      sx={{ width, height }}
    >
      <g id="policy-management">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M40.047 3C40.577 3 41.086 3.211 41.461 3.586L59.414 21.539C59.789 21.914 60 22.423 60 22.953V40.5C58.5 39.8 56.9 39.3 55.2 39V25.313H37.688V8.667H15.667C15.115 8.667 14.667 9.115 14.667 9.667V60.083C14.667 60.635 15.115 61.083 15.667 61.083H37.5C38.8 63.2 40.6 65 42.8 66.75H15.375C13.684 66.75 12.063 66.078 10.867 64.883C9.672 63.687 9 62.066 9 60.375V9.375C9 7.684 9.672 6.063 10.867 4.867C12.063 3.672 13.684 3 15.375 3H40.047ZM21.75 46.917H35.5C34.6 48.5 33.9 50.2 33.5 52.583H21.75V46.917ZM21.75 35.583H47.25V41.25H21.75V35.583Z"
          fill={color}
        />
        <g transform="translate(41, 41) scale(1.17)">
          <path
            d="M19.14,12.94c0.04-0.3,0.06-0.61,0.06-0.94c0-0.32-0.02-0.64-0.07-0.94l2.03-1.58c0.18-0.14,0.23-0.41,0.12-0.61l-1.92-3.32c-0.12-0.22-0.37-0.29-0.59-0.22l-2.39,0.96c-0.5-0.38-1.03-0.7-1.62-0.94L14.4,2.81c-0.04-0.24-0.24-0.41-0.48-0.41h-3.84c-0.24,0-0.43,0.17-0.47,0.41L9.25,5.35C8.66,5.59,8.12,5.92,7.63,6.29L5.24,5.33c-0.22-0.08-0.47,0-0.59,0.22L2.74,8.87C2.62,9.08,2.66,9.34,2.86,9.48l2.03,1.58C4.84,11.36,4.8,11.69,4.8,12s0.02,0.64,0.07,0.94l-2.03,1.58c-0.18,0.14-0.23,0.41-0.12,0.61l1.92,3.32c0.12,0.22,0.37,0.29,0.59,0.22l2.39-0.96c0.5,0.38,1.03,0.7,1.62,0.94l0.36,2.54c0.05,0.24,0.24,0.41,0.48,0.41h3.84c0.24,0,0.44-0.17,0.47-0.41l0.36-2.54c0.59-0.24,1.13-0.56,1.62-0.94l2.39,0.96c0.22,0.08,0.47,0,0.59-0.22l1.92-3.32c0.12-0.22,0.07-0.47-0.12-0.61L19.14,12.94z M12,15.6c-1.98,0-3.6-1.62-3.6-3.6s1.62-3.6,3.6-3.6s3.6,1.62,3.6,3.6S13.98,15.6,12,15.6z"
            fill={color}
          />
        </g>
      </g>
    </SvgIcon>
  );
};

PolicyManagementIcon.muiName = "SvgIcon";

export default PolicyManagementIcon;
